export default __webpack_public_path__ + "static/grid-63d07b39c82dfe1bd726edfbf5781ab4.png";